const fontSize = 15;

export const getDrawPathSectionOptions = (pathSection) => {
  const isVertical =
    pathSection.isInterGround() && Math.abs(pathSection.getInclination()) > 10;
  const min = 150;
  return {
    drawOptions: {
      speed: 5,
      centerOnOptions: {
        zoom: true,
        altitude: isVertical ? 0 : 50,
        time: 1500,
        fitRatio: 1.2,
        minDistance: min,
        maxDistance: 1000,
      },
    },
    setCurrentFloorOptions: {
      centerOnOptions: {
        zoom: true,
        altitude: isVertical ? 45 : 50,
        time: 1500,
        minDistance: min,
        maxDistance: 1000,
      },
    },
  };
};

export const iconLabelStyle = {
  offset: {
    x: 0,
    y: 250,
    z: 350,
  },
  style: {
    backgroundColor: "#22419a",
    backgroundOpacity: 0.9,
    backgroundRadius: 10,
    color: "#ffffff",
    size: fontSize,
  },
};

export const labelStyle = {
  arrival: {
    offset: {
      x: 0,
      y: 0,
      z: 60,
    },
    style: {
      backgroundColor: "#0e5aa7",
      backgroundOpacity: 0.9,
      backgroundRadius: 10,
      color: "#ffffff",
      size: 15,
    },
  },
  interchange: {
    offset: {
      x: -20,
      y: 5,
      z: 150,
    },
    style: {
      backgroundColor: "#22419a",
      backgroundOpacity: 0.9,
      backgroundRadius: 10,
      color: "#ffffff",
      size: fontSize,
    },
  },
  userObject: {
    offset: {
      x: 0,
      y: 0,
      z: 80,
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/constants.js